'use client'
import { useState } from 'react'
import { usePopper } from 'react-popper'
import clsx from 'clsx'
import Link from 'next/link'

import { ICONS } from '@constants/icons.constants'

import { RaIcon, RaNavbarDropdown, RaTypography } from '../index.core'

import styles from './ra-navbar-menu.module.scss'

import { stripFrontendUrl } from '@/utilities/helpers/strip-fe-url.helpers'

export const RaNavbarMenu = ({
  menu,
  index,
  renderNavbar,
  dropdownOpen,
  setDropdownOpen,
  initialActive,
}) => {
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)

  const { styles: popperStyles, attributes } = usePopper(
    referenceElement,
    popperElement,
    {
      placement: 'bottom-start',
      modifiers: [
        { name: 'offset', options: { offset: [0, 0] } },
        { name: 'preventOverflow', options: { padding: 12 } },
        {
          name: 'flip',
          options: { fallbackPlacements: ['bottom', 'bottom-end'] },
        },
      ],
    }
  )

  const handleKeyDown = e => {
    if (e.code == 'Escape') {
      setDropdownOpen(false)
    } else {
      const isValidKey =
        e.code === 'ArrowDown' || e.code === 'Enter' || e.code === 'Space'
      if (isValidKey && !dropdownOpen) {
        e.preventDefault()
        setDropdownOpen(menu.link?.title)
      }
    }
  }

  return (
    <nav
      ref={setReferenceElement}
      className={clsx(
        styles['ra-navbar__menu-item'],
        dropdownOpen && styles['ra-navbar__menu-item--active']
      )}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      title={menu.link?.title}>
      {menu.link?.url !== '#' ? (
        <Link
          href={stripFrontendUrl(menu.link?.url)}
          title={menu.link?.title}
          target={menu.link?.target}
          className={styles['ra-navbar__menu-title']}
          tabIndex={-1}>
          <RaTypography
            component="span"
            fontFamily="heading"
            size="l"
            color={renderNavbar ? 'off-black' : 'light'}>
            {menu.link?.title}
            <RaIcon icon={ICONS.CHEVRON_DOWN} />
          </RaTypography>
        </Link>
      ) : (
        <div className={styles['ra-navbar__menu-title']}>
          <RaTypography
            component="span"
            fontFamily="heading"
            size="l"
            color={renderNavbar ? 'off-black' : 'light'}>
            {menu.link?.title}
            <RaIcon icon={ICONS.CHEVRON_DOWN} />
          </RaTypography>
        </div>
      )}
      <div
        ref={setPopperElement}
        style={popperStyles.popper}
        className={styles['ra-navbar__menu-item__popper']}
        {...attributes.popper}>
        <RaNavbarDropdown
          key={index}
          menu={menu}
          isOpen={dropdownOpen}
          initialActive={initialActive}
        />
      </div>
    </nav>
  )
}
